import arrayMove from 'array-move';
import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { addApartmentMedia, addApartmentMediaFail, addApartmentMediaSuccess, confirmMedia, confirmMediaSuccess, createApartment, createApartmentFail, createApartmentSuccess, deleteApartmentMedia, deleteApartmentMediaFail, deleteApartmentMediaSuccess, reorderApartmentMedia, reorderApartmentMediaFail, getAllMedia, getAllMediaFail, getAllMediaSuccess, getApartment, getApartmentFail, getApartmentMedia, getApartmentMediaFail, getApartmentMediaSuccess, getApartmentSuccess, listApartments, listApartmentsFail, listApartmentsSuccess, removeApartment, removeApartmentFail, removeApartmentSuccess, updateApartmentCode, updateApartmentCodeSuccess, updateApartmentCodeFail, stepBack, stepClick, stepForward, stepInstantRentForward, updateApartmentAdminInfo, updateApartmentAdminInfoFail, updateApartmentAdminInfoSuccess, updateApartmentClientInformation, updateApartmentClientInformationFail, updateApartmentClientInformationSuccess, updateApartmentConfirmation, updateApartmentConfirmationFail, updateApartmentConfirmationSuccess, updateApartmentInformation, updateApartmentInformationFail, updateApartmentInformationSuccess, updateApartmentClientInformationToOverview, updateApartmentClientInformationToOverviewSuccess, updateApartmentClientInformationToOverviewFail, updateApartmentMedia, updateApartmentMediaSuccess, updateApartmentMediaFail, updateStatus, updateStatusFail, updateStatusSuccess, updateStatusWithForm, updateStatusWithFormFail, updateStatusWithFormSuccess, updateApartmentUserId, updateApartmentUserIdFail, updateApartmentUserIdSuccess, initializeBeforeLoginApartment, saveBeforeLoginApartmentInfo, saveInstantRentApplicationInfo, addBeforeLoginApartmentMedia, deleteBeforeLoginApartmentMedia, reorderBeforeLoginApartmentMedia, confirmBeforeLoginApartmentMedia, confirmBeforeLoginApartment, addMissingClientInfo, addMissingClientInfoToOverview, updateApartmentViewed, searchApartments, searchApartmentsSuccess, searchApartmentsFail, getApartmentByCodeSuccess, getApartmentByCodeFail, getApartmentByCode, signUpBeforeLogin, addSwitchedData, updateApartmentClientInformationWithStatus, updateApartmentClientInformationWithStatusSuccess, updateApartmentClientInformationWithStatusFail, instantRentStepCLick, stepInstantRentBack, stepAfterShowingForward, stepAfterShowingBack } from '../actions/apartments';
import { updateApplicationSuccess } from '../actions/applications';
import { closeDialog } from '../actions/dialogs';
import { navigate } from '../actions/routes';
import { updateUser } from '../actions/users';
import { addFormSubmit, addStepCompletion } from '../config/googleTagManager';
import { showParking } from '../containers/Apartment/Forms/ApartmentConfirmationForm';
import { UpdateStatusWithFormFormData } from '../containers/Apartments/AdminView/updateStatusForm';
import { getIdFromS3Key } from '../libs/strings';
import { selectApartmentById, selectApartmentFilesByApartmentId, selectSelectedApartmentId, selectApartmentsAsArray } from '../selectors/apartments';
import { selectContentIdFromPathname, selectStepNumberFromPathname, selectUserIdFromPathname, selectBeforeLoginStepNumberFromPathname, selectInstantRentStepNumberFromPathname, selectAfterShowingStepNumberFromPathname, selectApartmentStatusFromPathname, selectNewApplicationApartmentCodeFromPathname, selectApplicationCodeFromPathname } from '../selectors/router';
// @ts-ignore
import { selectIsAdminUser } from '../selectors/users';
import Api from '../services/apartments';
import ApplicationsApi from '../services/applications';
import { getAllMediaObjects, getApartmentMediaObjects, getFileURL, getThumbURL, uploadApartmentImageFileToS3 } from '../services/storage/s3';
import { ApartmentsBucketList, BucketObject, UploadFileToS3Response } from '../services/storage/types';
import i18n from '../translations/i18n';
import { ApartmentAdminInfo, ApartmentClientInformation, ApartmentInformation, Apartment, UpdateApartmentUserIdProps, ApartmentMedia, ApartmentMediaItem } from '../types/apartments';
import { ImageFileWithObjectURL, IndexedFilesAndMetadata } from '../types/files';
import { HandleUpdateApartmentAdminInfoParameters, HandleUpdateApartmentClientParameters, HandleUpdateApartmentInfoParameters, FormPayloadParameters } from '../types/formData';
import { StepCompletionEventNames, ListingCreationSteps } from '../types/GTM';
import { hasOtherOwnerDataIfNeeded, generateApartmentAddress } from '../utils/apartments';
import { validateHasTooManyImages } from '../utils/validation/apartments';
import { isAdminHelper, validateIsAdmin } from '../utils/validation/users';
import { handleInitializeBeforeLoginApartment, handleSaveBeforeLoginApartmentInfo, handleAddBeforeLoginApartmentMedia, handleDeleteBeforeLoginApartmentMedia, handleReorderBeforeLoginApartmentMedia, handleConfirmBeforeLoginApartmentMedia, handleConfirmBeforeLoginApartment, handleAddMissingClientInfo, handleAddMissingClientInfoToOverview, handleSignUpBeforeLogin } from './apartments/beforeLoginApartments';
import { handleSaveInstantRentInfo } from './apartments/instantRent';
import { deleteUnneededClientInfo, deleteUnneededConfirmData, deleteUnneededApartmentInfo } from './helpers/apartments';
function* handleCreateApartment(): SagaIterator {
    try {
        const apartment = yield call(Api.createApartment);
        yield put(createApartmentSuccess(apartment));
        yield put(navigate(`/users/${apartment.userId}/apartments/${apartment.apartmentId}/steps/0`));
        addStepCompletion(StepCompletionEventNames.listingCreation, '0_entered_funnel');
    }
    catch (error: any) {
        yield put(createApartmentFail((error as any).message));
    }
}
type handleRemoveApartmentParameters = {
    payload: string;
};
function* handleRemoveApartment({ payload: apartmentId }: handleRemoveApartmentParameters): SagaIterator {
    try {
        const { userId }: Apartment = yield select(selectApartmentById(apartmentId));
        yield call(Api.removeApartment, userId, apartmentId);
        yield put(removeApartmentSuccess(apartmentId));
    }
    catch (error: any) {
        yield put(removeApartmentFail((error as any).message));
    }
}
type handleUpdateApartmentCodeParameters = {
    payload: string;
};
function* handleUpdateApartmentCode({ payload: apartmentId }: handleUpdateApartmentCodeParameters): SagaIterator {
    try {
        const { userId }: Apartment = yield select(selectApartmentById(apartmentId));
        yield call(Api.updateApartmentCode, userId, apartmentId);
        yield put(updateApartmentCodeSuccess(apartmentId));
    }
    catch (error: any) {
        yield put(updateApartmentCodeFail((error as any).message));
    }
}
export function* handleListApartments({ payload: status }: {
    payload: string | undefined;
}): SagaIterator {
    try {
        const apartments: Apartment[] = yield call(Api.getApartments, { status });
        yield put(listApartmentsSuccess(apartments));
        const isAdmin = yield call(isAdminHelper);
        if (!isAdmin) {
            yield put(getAllMedia(apartments));
        }
    }
    catch (error: any) {
        yield put(listApartmentsFail((error as any).message));
    }
}
export function* handleSearchApartments({ payload: query }: {
    payload: string | undefined;
}): SagaIterator {
    try {
        const status: string = yield select(selectApartmentStatusFromPathname);
        const apartments: Apartment[] = yield call(Api.getApartments, {
            query,
            status
        });
        yield put(searchApartmentsSuccess(apartments));
    }
    catch (error: any) {
        yield put(searchApartmentsFail((error as any).message));
    }
}
export function* handleGetApartment({ payload: { userId, apartmentId } }: any): SagaIterator {
    try {
        const apartment: Apartment = yield call(Api.getApartment, userId, apartmentId);
        yield put(getApartmentSuccess(apartment));
    }
    catch (error: any) {
        yield put(getApartmentFail((error as any).message));
    }
}
export function* handleGetApartmentByCode({ payload: apartmentCode }: {
    payload: string;
}): SagaIterator {
    try {
        const apartment: Apartment = yield call(Api.getApartmentByCode, apartmentCode);
        yield put(getApartmentByCodeSuccess(apartment));
    }
    catch (error: any) {
        yield put(getApartmentByCodeFail((error as any).message));
    }
}
export function* handleUpdateApartmentClientInformation({ payload: { formData, resolve, reject } }: HandleUpdateApartmentClientParameters): SagaIterator {
    try {
        const apartmentId: string = formData.apartment
            ? formData.apartment?.apartmentId
            : yield select(selectContentIdFromPathname);
        const { userId, metadata }: Apartment = formData.apartment
            ? formData.apartment
            : yield select(selectApartmentById(apartmentId));
        const isAlreadyConfirmed = metadata;
        //OLD FEAURE, NOT SURE IF IT`S NEEDED IN NEW UI PIPELINE
        // const isAdmin: boolean = yield select(selectIsAdminUser)
        // if (metadata.confirmed && !isAdmin) {
        //   yield put(navigate(`/users/${userId}/apartments/${apartmentId}/overview`))
        //   return
        // }
        if (hasOtherOwnerDataIfNeeded(formData)) {
            const streetAddress = typeof formData?.mainOwner?.autocompleteLocation === 'string'
                ? formData?.mainOwner?.autocompleteLocation
                : formData?.mainOwner?.autocompleteLocation?.label;
            const client: ApartmentClientInformation = deleteUnneededClientInfo({
                ...formData
            });
            // sms api format is no plus, countrycode and phone (without leading zero)
            client.mainOwner = {
                ...client.mainOwner,
                streetAddress,
                address: generateApartmentAddress({
                    streetAddress,
                    buildingLetter: formData.mainOwner.buildingLetter,
                    apartmentNumber: formData.mainOwner.apartmentNumber
                })
            };
            const apartment: Apartment = yield call(Api.updateApartmentClientInformation, userId, apartmentId, client);
            yield put(updateApartmentClientInformationSuccess(apartment));
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/payment`));
            // don't send GTM data for admin actions
            if (!isAlreadyConfirmed) {
                addFormSubmit('apartmentOwnerContactInfo');
                addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.filledContactDetails);
            }
            resolve();
        }
        else {
            yield call(reject, new SubmissionError({
                _error: i18n.t('error.client.otherOwnerNotDefined')
            }));
            yield put(updateApartmentClientInformationFail(i18n.t('error.client.otherOwnerNotDefined')));
        }
    }
    catch (error: any) {
        yield put(updateApartmentClientInformationFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* handleUpdateApartmentClientInformationToOverview({ payload: { formData, resolve, reject } }: HandleUpdateApartmentClientParameters): SagaIterator {
    try {
        const apartmentId: string = formData.apartment
            ? formData.apartment?.apartmentId
            : yield select(selectContentIdFromPathname);
        const { userId, metadata }: Apartment = formData.apartment
            ? formData.apartment
            : yield select(selectApartmentById(apartmentId));
        const isAlreadyConfirmed = metadata;
        const { editMode } = formData;
        delete formData.editMode;
        //OLD FEAURE, NOT SURE IF IT`S NEEDED IN NEW UI PIPELINE
        // const isAdmin: boolean = yield select(selectIsAdminUser)
        // if (metadata.confirmed && !isAdmin) {
        //   yield put(navigate(`/users/${userId}/apartments/${apartmentId}/overview`))
        //   return
        // }
        if (hasOtherOwnerDataIfNeeded(formData)) {
            const streetAddress = typeof formData?.mainOwner?.autocompleteLocation === 'string'
                ? formData?.mainOwner?.autocompleteLocation
                : formData?.mainOwner?.autocompleteLocation?.label;
            const client: ApartmentClientInformation = deleteUnneededClientInfo({
                ...formData
            });
            // sms api format is no plus, countrycode and phone (without leading zero)
            client.mainOwner = {
                ...client.mainOwner,
                streetAddress,
                address: generateApartmentAddress({
                    streetAddress,
                    buildingLetter: formData.mainOwner.buildingLetter,
                    apartmentNumber: formData.mainOwner.apartmentNumber
                })
            };
            const apartment: Apartment = yield call(Api.updateApartmentClientInformation, userId, apartmentId, client);
            yield put(updateApartmentClientInformationToOverviewSuccess(apartment));
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/overview`));
            // don't send GTM data for admin actions
            if (!isAlreadyConfirmed) {
                addFormSubmit('apartmentOwnerContactInfo');
                addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.filledContactDetails);
            }
            let overviewMessage;
            if (editMode) {
                overviewMessage = i18n.t('general.changesSaved');
            }
            else {
                overviewMessage = i18n.t('apartment.overview.firstTimeMessage');
            }
            //const overviewMessage = i18n.t('apartment.overview.firstTimeMessage')
            toast.info(overviewMessage, { autoClose: 30000 });
            resolve();
        }
        else {
            yield call(reject, new SubmissionError({
                _error: i18n.t('error.client.otherOwnerNotDefined')
            }));
            yield put(updateApartmentClientInformationToOverviewFail(i18n.t('error.client.otherOwnerNotDefined')));
        }
    }
    catch (error: any) {
        yield put(updateApartmentClientInformationToOverviewFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* handleUpdateApartmentClientInformationWithStatus({ payload: { formData, resolve, reject } }: HandleUpdateApartmentClientParameters): SagaIterator {
    try {
        const apartmentId: string = formData.apartment
            ? formData.apartment?.apartmentId
            : yield select(selectContentIdFromPathname);
        const { userId, metadata }: Apartment = formData.apartment
            ? formData.apartment
            : yield select(selectApartmentById(apartmentId));
        const isAlreadyConfirmed = metadata;
        //OLD FEAURE, NOT SURE IF IT`S NEEDED IN NEW UI PIPELINE
        // const isAdmin: boolean = yield select(selectIsAdminUser)
        // if (metadata.confirmed && !isAdmin) {
        //   yield put(navigate(`/users/${userId}/apartments/${apartmentId}/overview`))
        //   return
        // }
        if (hasOtherOwnerDataIfNeeded(formData)) {
            const streetAddress = typeof formData?.mainOwner?.autocompleteLocation === 'string'
                ? formData?.mainOwner?.autocompleteLocation
                : formData?.mainOwner?.autocompleteLocation?.label;
            const client: ApartmentClientInformation = deleteUnneededClientInfo({
                ...formData
            });
            // sms api format is no plus, countrycode and phone (without leading zero)
            client.mainOwner = {
                ...client.mainOwner,
                streetAddress,
                address: generateApartmentAddress({
                    streetAddress,
                    buildingLetter: formData.mainOwner.buildingLetter,
                    apartmentNumber: formData.mainOwner.apartmentNumber
                })
            };
            const apartment: Apartment = yield call(Api.updateApartmentClientInformation, userId, apartmentId, client);
            const apartmentWithStatus: Apartment = yield call(Api.updateStatus, userId, apartmentId, { status: 'marketing' });
            const files: BucketObject[] | undefined = yield select(selectApartmentFilesByApartmentId(apartmentId));
            const hasMedia = files && files.length > 0;
            const message = hasMedia
                ? i18n.t('apartment.confirmation.success')
                : i18n.t('apartment.confirmation.successNoMedia');
            toast.info(message, { autoClose: 15000 });
            toast.info(i18n.t('apartments.status.setSuccess'), { autoClose: 15000 });
            yield put(updateApartmentClientInformationWithStatusSuccess(apartmentWithStatus));
            yield put(updateApartmentClientInformationSuccess(apartment));
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/overview`));
            // don't send GTM data for admin actions
            if (!isAlreadyConfirmed) {
                addFormSubmit('apartmentOwnerContactInfo');
                addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.filledContactDetails);
            }
            resolve();
        }
        else {
            yield call(reject, new SubmissionError({
                _error: i18n.t('error.client.otherOwnerNotDefined')
            }));
            yield put(updateApartmentClientInformationFail(i18n.t('error.client.otherOwnerNotDefined')));
        }
    }
    catch (error: any) {
        yield put(updateApartmentClientInformationFail((error as any).message));
        yield put(updateApartmentClientInformationWithStatusFail());
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* handleUpdateApartmentInformation({ payload: { formData, resolve, reject } }: HandleUpdateApartmentInfoParameters): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const { userId, metadata }: Apartment = yield select(selectApartmentById(apartmentId));
        //const isAdmin: boolean = yield select(selectIsAdminUser)
        const isAlreadyConfirmed = metadata.confirmed;
        // if (isAlreadyConfirmed && !isAdmin) {
        //   yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/9`))
        //   return
        // }
        const streetAddress = typeof formData?.autocompleteLocation === 'string'
            ? formData?.autocompleteLocation
            : formData?.autocompleteLocation?.label;
        const { price, availableFromDate, waterFeeBasis, waterFee, ...reqRawData } = formData;
        if (price !== undefined) {
            yield put(addSwitchedData({
                availableFromDate,
                price: parseInt(price).toString()
            }));
        }
        if (reqRawData.notes == undefined)
            reqRawData.notes = '';
        const switchDataObj = {
            availableFromDate,
            price: parseInt(price).toString(),
            waterFeeBasis,
            waterFee
        };
        waterFeeBasis === 'included' && delete switchDataObj.waterFee;
        const formInformation: ApartmentInformation = {
            ...reqRawData,
            streetAddress,
            address: generateApartmentAddress({
                streetAddress,
                streetNumber: formData?.streetNumber,
                // UI IS MISSING SUCH FIELDS, NO NEED THAT FOR NOW
                buildingLetter: formData.buildingLetter,
                apartmentNumber: formData.apartmentNumber
            })
        };
        const information = deleteUnneededApartmentInfo(formInformation);
        const reqInformation: ApartmentInformation = {
            ...information,
            energyCertification: typeof information.energyCertification === 'object'
                ? (information.energyCertification as any)['value']
                : information.energyCertification,
            postalArea: typeof information.postalArea === 'object'
                ? (information.postalArea as any)['value']
                : information.postalArea,
            heating: 'electric',
            parking: 'no',
            petsAllowed: 'no',
            sauna: 'no',
            storage: 'no'
        };
        const apartment: Apartment = yield call(Api.updateApartmentInformation, userId, apartmentId, reqInformation);
        yield put(updateApartmentInformationSuccess(apartment));
        // Remove background AI improvements; generation is now user-triggered in UI
        if (price !== undefined) {
            yield put(addSwitchedData({
                apartment,
                ...switchDataObj
            }));
        }
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/9`));
        // don't send GTM data for admin actions
        if (!isAlreadyConfirmed) {
            addFormSubmit('apartmentInfo');
            addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.filledListingDetails);
        }
        resolve();
    }
    catch (error: any) {
        yield put(updateApartmentInformationFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* handleUpdateApartmentMedia({ payload: { userId, apartmentId, media } }: {
    payload: {
        userId: string;
        apartmentId: string;
        media: ApartmentMedia;
    };
}): SagaIterator {
    try {
        const apartment: Apartment = yield call(Api.updateApartmentMedia, userId, apartmentId, media);
        yield put(updateApartmentMediaSuccess(apartment));
    }
    catch (error: any) {
        yield put(updateApartmentMediaFail((error as any).message));
    }
}
export function* handleUpdateApartmentAdminInfo({ payload: { formData, resolve, reject } }: HandleUpdateApartmentAdminInfoParameters): SagaIterator {
    try {
        yield call(validateIsAdmin);
        const apartmentId: string = yield select(selectSelectedApartmentId);
        const { userId } = yield select(selectApartmentById(apartmentId));
        const adminInfo: ApartmentAdminInfo = { ...formData };
        const apartment: Apartment = yield call(Api.updateApartmentAdminInfo, userId, apartmentId, adminInfo);
        toast.info(i18n.t('apartment.adminInfo.success'), { autoClose: 15000 });
        yield put(updateApartmentAdminInfoSuccess(apartment));
        yield put(closeDialog(i18n.t('apartment.adminInfo.button')));
        resolve();
    }
    catch (error: any) {
        yield put(updateApartmentAdminInfoFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* uploadFile(file: any, apartmentId: string): SagaIterator {
    const { key }: UploadFileToS3Response = yield call(uploadApartmentImageFileToS3, file, apartmentId);
    return key;
}
export function* handleAddApartmentMedia({ payload: { formData: { files }, resolve, reject } }: any): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const existingApartmentMedia = yield select(selectApartmentFilesByApartmentId(apartmentId));
        const indexedFilesAndMetadatas: IndexedFilesAndMetadata = files;
        const allMedia = [
            ...Object.keys(indexedFilesAndMetadatas),
            ...existingApartmentMedia
        ];
        validateHasTooManyImages(allMedia);
        const uploadedFiles = yield all(files.map((file: ImageFileWithObjectURL) => uploadFile(file, apartmentId)));
        yield put(addApartmentMediaSuccess());
        yield put(getApartmentMedia(apartmentId));
        const { userId, media } = yield select(selectApartmentById(apartmentId));
        uploadedFiles.forEach((key: string) => {
            if (!media.find((mediaItem: {
                key: string;
            }) => mediaItem.key === key)) {
                media.push({
                    id: getIdFromS3Key(key),
                    key
                });
            }
        });
        yield put(updateApartmentMedia({
            userId,
            apartmentId,
            media
        }));
        addFormSubmit('addApartmentMedia');
        resolve();
    }
    catch (error: any) {
        yield call(reject, new SubmissionError({
            _error: (error as any).message === 'tooMany'
                ? i18n.t('error.mediaUpload.tooMany')
                : i18n.t('error.mediaUpload.formFail')
        }));
        yield put(addApartmentMediaFail((error as any).message));
    }
}
function* appendObjectWithUrl(object: BucketObject): SagaIterator {
    const url = yield call(getFileURL, object.key);
    let thumbUrl: string | undefined;
    try {
        thumbUrl = yield call(getThumbURL, object.key);
    } catch {
        // thumbnail may not exist yet
    }
    return {
        ...object,
        url,
        thumbUrl,
    };
}
export function* handleDeleteApartmentMedia({ payload: key }: any): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const { userId, media }: Apartment = yield select(selectApartmentById(apartmentId));
        yield call(Api.deleteApartmentMedia, userId, apartmentId, { key });
        yield put(deleteApartmentMediaSuccess({ apartmentId, key }));
        const newApartmentMedia = Array.isArray(media)
            ? media.filter((mediaItem) => mediaItem.key !== key)
            : [];
        yield put(updateApartmentMedia({
            userId,
            apartmentId,
            media: newApartmentMedia
        }));
        yield call((): Promise<void> => new Promise(resolve => setTimeout(resolve, 250)));
        sessionStorage.removeItem('isDeletingImage');
    }
    catch (error: any) {
        yield put(deleteApartmentMediaFail((error as any).message));
    }
}
export function* handleReorderApartmentMedia({ payload: { oldIndex, newIndex } }: {
    payload: {
        oldIndex: number;
        newIndex: number;
    };
}): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const { userId, media } = yield select(selectApartmentById(apartmentId));
        const apartmentMediaNew: ApartmentMedia = arrayMove<ApartmentMediaItem>(media, oldIndex, newIndex);
        const appartment = yield call(Api.updateApartmentMedia, userId, apartmentId, apartmentMediaNew);
        yield put(updateApartmentMediaSuccess(appartment));
    }
    catch (error: any) {
        yield put(reorderApartmentMediaFail((error as any).message));
    }
}
export function* handleConfirmMedia(): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        const apartmentFromState: Apartment = yield select(selectApartmentById(apartmentId));
        const files = yield select(selectApartmentFilesByApartmentId(apartmentId));
        // const isAdmin: boolean = yield select(selectIsAdminUser);
        if (files.length > 0) {
            const apartment: Apartment = apartmentFromState.metadata.media
                ? apartmentFromState
                : yield call(Api.confirmApartmentMedia, apartmentFromState.userId, apartmentId);
            yield put(confirmMediaSuccess(apartment));
            if (!apartment.metadata.confirmed) {
                yield put(navigate(`/users/${apartmentFromState.userId}/apartments/${apartmentId}/steps/11`));
                addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.proceededFromPhotos);
            }
            else {
                // if (apartment.metadata.marketing && !isAdmin) {
                //   yield put(
                //     navigate(
                //       `/users/${apartmentFromState.userId}/apartments/${apartmentId}/overview`
                //     )
                //   )
                //   const overviewMessage = i18n.t('general.changesSaved')
                //   toast.info(overviewMessage, { autoClose: 30000 });
                //   return
                // }
                yield put(navigate(`/users/${apartmentFromState.userId}/apartments/${apartmentId}/steps/11`));
            }
            addFormSubmit('confirmApartmentMedia');
        }
        else {
            const noMediaMessage = i18n.t('apartment.mediaUpload.noMedia');
            yield call(toast.error, noMediaMessage);
            throw new Error('Images required');
        }
    }
    catch (error: any) {
        yield put(getApartmentFail((error as any).message));
    }
}
export function* handleUpdateApartmentConfirmation({ payload: { formData, resolve, reject } }: any): SagaIterator {
    try {
        const apartmentId: string = yield select(selectContentIdFromPathname);
        //const isAdmin: boolean = yield select(selectIsAdminUser)
        const { userId, metadata, information, switchedData }: Apartment = yield select(selectApartmentById(apartmentId));
        const isAlreadyConfirmed = metadata.confirmed;
        // if (!isAdmin) {
        //   // when apartment is already confirmed, do not try to confirm it again
        //   yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/11`))
        //   return
        // }
        const confirmationRaw = {
            ...formData,
            ...switchedData,
            // Step 2 owns availableFromDate; a cleared picker stores null, which the API rejects, so send undefined (key omitted)
            ...(switchedData && { availableFromDate: switchedData.availableFromDate || undefined })
        };
        if (confirmationRaw.confirm && information) {
            const parkingFeeNeeded = showParking(information.parking);
            const isSVAMember: boolean = confirmationRaw.isSVAMember || false;
            const confirmation = deleteUnneededConfirmData(confirmationRaw, parkingFeeNeeded);
            const vuokraoviCollateralFromStorage = localStorage.getItem('vuokraoviCollateral');
            let vuokraoviCollateral;
            if (vuokraoviCollateralFromStorage !== null) {
                vuokraoviCollateral = vuokraoviCollateralFromStorage === 'true';
                localStorage.removeItem('vuokraoviCollateral');
            }
            const contactInfoPublicOnPlatformsFromStorage = localStorage.getItem('contactInfoPublicOnPlatforms');
            let contactInfoPublicOnPlatforms;
            if (contactInfoPublicOnPlatformsFromStorage !== null) {
                contactInfoPublicOnPlatforms = contactInfoPublicOnPlatformsFromStorage === 'true';
                localStorage.removeItem('contactInfoPublicOnPlatforms');
            }
            const apartment: Apartment = yield call(Api.updateApartmentConfirmation, userId, apartmentId, {
                ...confirmation,
                ...(vuokraoviCollateralFromStorage !== null && { vuokraoviCollateral }),
                ...(contactInfoPublicOnPlatformsFromStorage !== null && { contactInfoPublicOnPlatforms })
            });
            yield put(updateUser({ userId, userData: { isSVAMember } }));
            yield put(updateApartmentConfirmationSuccess(apartment));
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/11`));
            // don't send GTM data for admin actions
            if (!isAlreadyConfirmed) {
                addFormSubmit('apartmentContractDetails');
                addStepCompletion(StepCompletionEventNames.listingCreation, ListingCreationSteps.submittedListing);
            }
            resolve();
        }
        else {
            yield call(reject, new SubmissionError({
                _error: i18n.t('apartment.confirmation.confirmFalse')
            }));
            yield put(updateApartmentConfirmationFail(i18n.t('apartment.confirmation.confirmFalse')));
        }
    }
    catch (error: any) {
        yield put(updateApartmentConfirmationFail((error as any).message));
        yield call(reject, new SubmissionError({ _error: i18n.t('apartment.actions.formFail') }));
    }
}
export function* handleGetApartmentMedia({ payload: apartmentId }: any): SagaIterator {
    try {
        const bucketObjects = yield call(getApartmentMediaObjects, apartmentId);
        const bucketObjectsWithUrl: BucketObject[] = yield all(bucketObjects.map((object: BucketObject) => appendObjectWithUrl(object)));
        yield put(getApartmentMediaSuccess({ apartmentId, bucketObjectsWithUrl }));
    }
    catch (error: any) {
        yield put(getApartmentMediaFail((error as any).message));
    }
}
export function* handleGetAllMedia(): SagaIterator {
    try {
        const apartments = yield select(selectApartmentsAsArray);
        const apartmentBucketObjectArray: ApartmentsBucketList = apartments
            ? yield call(getAllMediaObjects, apartments)
            : [];
        yield put(getAllMediaSuccess(apartmentBucketObjectArray));
    }
    catch (error: any) {
        yield put(getAllMediaFail((error as any).message));
    }
}
export function* handleUpdateStatus({ payload: status }: any): SagaIterator {
    try {
        let apartmentId: string = yield select(selectSelectedApartmentId);
        if (yield select(selectContentIdFromPathname)) {
            apartmentId = yield select(selectContentIdFromPathname);
        }
        else {
            apartmentId = yield select(selectSelectedApartmentId);
        }
        const { userId } = yield select(selectApartmentById(apartmentId));
        const apartment: Apartment = yield call(Api.updateStatus, userId, apartmentId, { status });
        toast.info(i18n.t('apartments.status.setSuccess'), { autoClose: 15000 });
        yield put(updateStatusSuccess(apartment));
    }
    catch (error: any) {
        yield put(updateStatusFail());
    }
}
export function* handleUpdateStatusWithForm({ payload: { formData, resolve, reject } }: FormPayloadParameters<UpdateStatusWithFormFormData>): SagaIterator {
    try {
        const { contractWantedId: applicationId } = formData;
        let apartmentId: string = yield select(selectSelectedApartmentId);
        if (yield select(selectContentIdFromPathname)) {
            apartmentId = yield select(selectContentIdFromPathname);
        }
        else {
            apartmentId = yield select(selectSelectedApartmentId);
        }
        const { userId } = yield select(selectApartmentById(apartmentId));
        const application = yield call(ApplicationsApi.updateApplicationStatus, apartmentId, applicationId, {
            status: 'wantsContract'
        });
        const apartment: Apartment = yield call(Api.updateStatus, userId, apartmentId, { contractWantedId: formData?.contractWantedId, status: formData?.status });
        // yield call(Api.updateStatus, userId, apartmentId, formData)
        const dialogId = 'UpdateApartmentStatus';
        if (!formData?.isFromApplicationCard) {
            yield put(closeDialog(dialogId));
        }
        toast.info(i18n.t('apartments.status.setFormSuccess'), { autoClose: 15000 });
        yield put(closeDialog(`confirm-tenant-${applicationId}`));
        yield put(updateStatusSuccess(apartment));
        yield put(updateStatusWithFormSuccess());
        yield put(updateApplicationSuccess(application));
        resolve();
    }
    catch (error: any) {
        yield put(updateStatusFail((error as any).message));
        yield put(updateStatusWithFormFail());
        if (!formData?.isFromApplicationCard) {
            yield call(reject, new SubmissionError({
                _error: i18n.t('error.application.updateStatusFail')
            }));
        }
    }
}
function* handleStepBack({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectBeforeLoginStepNumberFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/create/apartment/steps/${toStep}`));
        }
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${toStep}`));
        }
    }
}
function* handleInstantRentStepBack({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectInstantRentStepNumberFromPathname);
        const apartmentCode = yield select(selectNewApplicationApartmentCodeFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/instant-rent/${apartmentCode}/steps/${toStep}`));
        }
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${toStep}`));
        }
    }
}
function* handleAfterShowingStepBack({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectAfterShowingStepNumberFromPathname);
        const applicationCode = yield select(selectApplicationCodeFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/aftershowing/${applicationCode}/steps/${toStep}`));
        }
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        if (step > 0) {
            const toStep = step - 1;
            yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${toStep}`));
        }
    }
}
function* handleStepForward({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectBeforeLoginStepNumberFromPathname);
        const toStep = step + 1;
        yield put(navigate(`/create/apartment/steps/${toStep}`));
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${step + 1}`));
    }
}
function* handleInstantRentStepForward({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectInstantRentStepNumberFromPathname);
        const apartmentCode = yield select(selectNewApplicationApartmentCodeFromPathname);
        const toStep = step + 1;
        yield put(navigate(`/instant-rent/${apartmentCode}/steps/${toStep}`));
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${step + 1}`));
    }
}
function* handleAfterShowingStepForward({ payload }: {
    payload?: {
        beforeLogin: boolean;
    };
}): SagaIterator {
    if (payload?.beforeLogin) {
        const step = yield select(selectAfterShowingStepNumberFromPathname);
        const applicationCode = yield select(selectApplicationCodeFromPathname);
        const toStep = step + 1;
        yield put(navigate(`/aftershowing/${applicationCode}/steps/${toStep}`));
    }
    else {
        const step = yield select(selectStepNumberFromPathname);
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${step + 1}`));
    }
}
function* handleStepClick({ payload: { step, beforeLogin } }: {
    payload: {
        step: number;
        beforeLogin?: boolean;
    };
}): SagaIterator {
    if (beforeLogin) {
        yield put(navigate(`/create/apartment/steps/${step}`));
    }
    else {
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${step}`));
    }
}
function* handleInstantRentStepClick({ payload: { step, beforeLogin } }: {
    payload: {
        step: number;
        beforeLogin?: boolean;
    };
}): SagaIterator {
    if (beforeLogin) {
        const apartmentCode = yield select(selectNewApplicationApartmentCodeFromPathname);
        yield put(navigate(`/instant-rent/${apartmentCode}/steps/${step}`));
    }
    else {
        const userId = yield select(selectUserIdFromPathname);
        const apartmentId = yield select(selectContentIdFromPathname);
        yield put(navigate(`/users/${userId}/apartments/${apartmentId}/steps/${step}`));
    }
}
export function* handleUpdateApartmentUserId({ payload: { formData, resolve, reject } }: FormPayloadParameters<UpdateApartmentUserIdProps>): SagaIterator {
    try {
        const apartmentId: string = yield select(selectSelectedApartmentId);
        const { userId } = yield select(selectApartmentById(apartmentId));
        const apartment: Apartment = yield call(Api.updateApartmentUserId, userId, apartmentId, formData);
        const dialogId = 'UpdateUserIdForm';
        yield put(closeDialog(dialogId));
        yield put(updateApartmentUserIdSuccess(apartment));
        resolve();
    }
    catch (error: any) {
        yield put(updateApartmentUserIdFail((error as any).message));
        yield call(reject, new SubmissionError({
            _error: i18n.t('updateApartmentUserId.dialog.error')
        }));
    }
}
export function* handleUpdateApartmentViewed({ payload: { userId, apartmentId } }: {
    payload: {
        userId: string;
        apartmentId: string;
    };
}): SagaIterator {
    yield call(Api.updateApartmentViewed, userId, apartmentId);
}
function* watchApartmentsActions(): SagaIterator {
    yield all([
        takeLatest(createApartment, handleCreateApartment),
        takeLatest(removeApartment, handleRemoveApartment),
        takeLatest(updateApartmentCode, handleUpdateApartmentCode),
        takeLatest(listApartments, handleListApartments),
        takeLatest(searchApartments, handleSearchApartments),
        takeLatest(getApartment, handleGetApartment),
        takeLatest(getApartmentByCode, handleGetApartmentByCode),
        takeLatest(updateApartmentClientInformation, handleUpdateApartmentClientInformation),
        takeLatest(updateApartmentClientInformationWithStatus, handleUpdateApartmentClientInformationWithStatus),
        takeLatest(updateApartmentClientInformationToOverview, handleUpdateApartmentClientInformationToOverview),
        takeLatest(updateApartmentInformation, handleUpdateApartmentInformation),
        takeLatest(updateApartmentMedia, handleUpdateApartmentMedia),
        takeLatest(updateApartmentConfirmation, handleUpdateApartmentConfirmation),
        takeLatest(updateApartmentAdminInfo, handleUpdateApartmentAdminInfo),
        takeLatest(addApartmentMedia, handleAddApartmentMedia),
        takeLatest(getApartmentMedia, handleGetApartmentMedia),
        takeLatest(getAllMedia, handleGetAllMedia),
        takeLatest(deleteApartmentMedia, handleDeleteApartmentMedia),
        takeLatest(reorderApartmentMedia, handleReorderApartmentMedia),
        takeLatest(confirmMedia, handleConfirmMedia),
        takeLatest(updateStatus, handleUpdateStatus),
        takeLatest(updateApartmentViewed, handleUpdateApartmentViewed),
        takeLatest(stepBack, handleStepBack),
        takeLatest(stepInstantRentBack, handleInstantRentStepBack),
        takeLatest(stepAfterShowingBack, handleAfterShowingStepBack),
        takeLatest(stepForward, handleStepForward),
        takeLatest(stepInstantRentForward, handleInstantRentStepForward),
        takeLatest(stepAfterShowingForward, handleAfterShowingStepForward),
        takeLatest(stepClick, handleStepClick),
        takeLatest(instantRentStepCLick, handleInstantRentStepClick),
        takeLatest(updateStatusWithForm, handleUpdateStatusWithForm),
        takeLatest(updateApartmentUserId, handleUpdateApartmentUserId),
        takeLatest(initializeBeforeLoginApartment, handleInitializeBeforeLoginApartment),
        takeLatest(saveBeforeLoginApartmentInfo, handleSaveBeforeLoginApartmentInfo),
        takeLatest(saveInstantRentApplicationInfo, handleSaveInstantRentInfo),
        takeLatest(addBeforeLoginApartmentMedia, handleAddBeforeLoginApartmentMedia),
        takeLatest(deleteBeforeLoginApartmentMedia, handleDeleteBeforeLoginApartmentMedia),
        takeLatest(reorderBeforeLoginApartmentMedia, handleReorderBeforeLoginApartmentMedia),
        takeLatest(confirmBeforeLoginApartmentMedia, handleConfirmBeforeLoginApartmentMedia),
        takeLatest(signUpBeforeLogin, handleSignUpBeforeLogin),
        takeLatest(confirmBeforeLoginApartment, handleConfirmBeforeLoginApartment),
        takeLatest(addMissingClientInfo, handleAddMissingClientInfo),
        takeLatest(addMissingClientInfoToOverview, handleAddMissingClientInfoToOverview)
    ]);
}
const apartmentsSagas = [watchApartmentsActions];
export default apartmentsSagas;
